module.exports = __webpack_public_path__ + "static/media/img_44.cc862f42.png";